NProgress.start(), $.fn.exists = function() {
  return $(this).length > 0
}, $.fn.inView = function() {
  var a = $(window);
  obj = $(this);
  var b = a.scrollTop(),
      c = a.scrollTop() + a.height(),
      d = obj.offset().top + 20;
  return c >= d && d >= b
};
var roar = {
  touch: !1,
  clickEv: "click",
  init: function() {
    roar.addToWishlist(), roar.removeFromWishlist(), roar.detectPlatform(), roar.notifyIE7Users(), roar.handleEffect(), roar.handleTooltip(), roar.handleCountdown(), roar.handleTabs(), roar.handleAjaxSearch(), roar.callbackSearchMobile(), roar.goToPage(), roar.handleFilter(), roar.handleSortby(), roar.sortSandBox(), roar.handleProducts(), roar.handleAccordion(), roar.handleScreenshotPreview(), roar.handleMenuMobile(), roar.callbackLoaded(), roar.handleDropdown(), roar.handleImageThumbs(), roar.resetProductImg(), roar.handleSlideshow(), roar.handleMap(), $(".noclose").click(function(a) {
      a.stopPropagation()
    }), roar.handleScrollToTop(), roar.handleSmoothScroll(), roar.handlePulsate(), roar.alwaysRefreshZoom(), roar.handleGridList(),$(".product-fancybox-buttons").length && $(".product-fancybox-buttons").fancybox({
      closeBtn: !1,
      helpers: {
        buttons: {}
      }
    })
  },
  handleEffect: function() {
    $(".animated:not(.shown)").exists() && (setTimeout(function() {
      roar.loadingEffect()
    }, 100), $(window).on("scroll", function() {
      roar.loadingEffect()
    }))
  },
  loadingEffect: function() {
    var a = $(".animated:not(.shown)");
    a.exists() && roar.precessEffect(a)
  },
  precessEffect: function(a) {
    var b = 0;
    a.each(function() {
      var a = $(this);
      $("html.touch").length > 0 ? a.hasClass("shown") || a.hasClass("animation-triggered") || (a.addClass("animation-triggered"), setTimeout(function() {
        a.hasClass("animation-triggered") && a.removeClass("animation-triggered").addClass("shown")
      }, 200)) : a.hasClass("shown") || a.hasClass("animation-triggered") || !a.inView() || (a.addClass("animation-triggered"), b++, setTimeout(function() {
        a.hasClass("animation-triggered") && a.removeClass("animation-triggered").addClass("shown")
      }, 100 * b))
    })
  },
  handleFilter: function() {
    var a, b, c = $(".advanced-filter");
    c.each(function() {
      var a = $(this);
      a.data("group"), a.hasClass("active-filter")
    }), c.on("click", function(c) {
      var d = $(this),
          e = d.data("group"),
          f = d.find("a").attr("href");
      d.hasClass("active-filter") || (a = $('.active-filter[data-group="' + e + '"]')) && a.data("group") === e && (c.preventDefault(), b = a.data("handle") + "+", f = f.replace(b, ""), window.location = f)
    })
  },
  isMobile: function() {
    return !!(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i))
  },
  sortSandBox: function() {
    $("#sandBox .product").removeClass("first"), $("#sandBox .product:nth-child(4n)").addClass("first")
  },
  getWidthBrowser: function() {
    var a;
    return "number" == typeof window.innerWidth ? a = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? a = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (a = document.body.clientWidth), a
  },
  getHeightBrowser: function() {
    var a;
    return "number" == typeof window.innerHeight ? a = window.innerHeight : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? a = document.documentElement.clientHeight : document.body && (document.body.clientWidth || document.body.clientHeight) && (a = document.body.clientHeight), a
  },
  handleAccordion: function() {
    $(".accordion-toggle").on("click", function() {
      !0 !== $(this).hasClass("collapsed") ? $(this).parents(".panel").removeClass("active") : $(this).parents(".panel").addClass("active")
    })
  },
  handleFocus: function() {
    $(".form-focus input").focus(function() {
      $(this).parents(".form-focus").addClass("focus")
    }).blur(function() {
      $(this).parents(".form-focus").removeClass("focus")
    })
  },
  handleBoxLogin: function() {
    $("#loginBox input").focus(function() {
      $(this).parents("#loginBox").addClass("focus")
    }).blur(function() {
      $(this).parents("#loginBox").removeClass("focus")
    })
  },
  handleDropdown: function() {
    $(".dropdown-link").on("click", function() {
      if (0 == roar.touch && roar.getWidthBrowser() > 980) {
        var a = $(this).attr("href");
        window.location = a
      }
    }), roar.handleBoxLogin(), roar.handleFocus()
  },
  handleScrollToTop: function() {
    function a(a) {
      var b = $("#scroll-top");
      b.removeClass("off on"), "on" == a ? b.addClass("on") : b.addClass("off")
    }
    $(window).scroll(function() {
      var b = $(this).scrollTop(),
          c = $(this).height();
      if (b > 0) var d = b + c / 2;
      else var d = 1;
      a(1e3 > d ? "off" : "on")
    }), $("#scroll-top").click(function(a) {
      a.preventDefault(), $("html,body").animate({
        scrollTop: 0
      }, 800, "swing")
    })
  },
  handleScreenshotPreview: function() {
    var a = 100,
        b = 50;
    $(".screenshot").hover(function(c) {
      $("body").append("<p id='screenshot'><span></span><img src='" + $(this).attr("data-rel") + "' alt='' /></p>"), $(this).hasClass("odd") ? $("#screenshot").css("top", c.pageY - a + "px").css("right", c.pageX + b + "px").fadeIn("fast") : $(this).hasClass("even") && $("#screenshot").css("top", c.pageY - a + "px").css("left", c.pageX + b + "px").fadeIn("fast")
    }, function() {
      $("#screenshot").remove()
    }), $(".screenshot").mousemove(function(c) {
      $(this).hasClass("odd") ? $("#screenshot").css("top", c.pageY - a + "px").css("right", c.pageX + b + "px") : $(this).hasClass("even") && $("#screenshot").css("top", c.pageY - a + "px").css("left", c.pageX + b + "px")
    })
  },
  handlePulsate: function() {
    jQuery().pulsate && (navigator.userAgent.match(/MSIE 8.0/) || jQuery().pulsate && (jQuery("#home-slider").on("mouseup", ".slider-control", function(a) {
      1 === a.which && $("#home-slider .slider-control .btn-label").pulsate({
        repeat: !1,
        reach: 10
      })
    }), jQuery("#home-slider").on("mouseup", ".pages .page", function(a) {
      $(this).hasClass("active") || 1 !== a.which || $(this).pulsate({
        color: window.slideshow_dots_colour,
        repeat: !1,
        reach: 10
      })
    }), jQuery("#home-slider").on("mouseup", ".camera_pag li", function(a) {
      $(this).hasClass("cameracurrent") || 1 !== a.which || $(this).pulsate({
        color: window.slideshow_dots_colour,
        repeat: !1,
        reach: 10
      })
    }), jQuery(".pulsate-regular").pulsate({
      reach: 20,
      speed: 1e3,
      pause: 1e3
    }), jQuery(".pulsate-regular2").pulsate({
      reach: 5,
      speed: 1e3,
      pause: 5e3
    }), jQuery(".pulsate-once").click(function() {
      $(this).pulsate({
        repeat: !1
      })
    }), jQuery(".pulsate-hover").pulsate({
      repeat: !1,
      onHover: !0
    }), jQuery(".pulsate-crazy").click(function() {
      $(this).pulsate({
        reach: 50,
        repeat: 10,
        speed: 100,
        glow: !0
      })
    })))
  },
  updateSlider: function() {
    if ($("#home-slider").length) {
      var a = $("#home-slider").data("slider");
      a && a.resize()
    }
  },
  updateCarousel: function() {
    if ($("#home-slider").length) {
      var a = $("#home-slider").data("slider");
      a && a.resize()
    }
  },
  updateCallback: function() {
    $("#product-related").length && ("scroll" == window.productspg_featured_style ? $("#product-related").mCustomScrollbar("update") : "carousel" == window.productspg_featured_style && $("#product-related").resize()), roar.updateSlider()
  },
  alwaysRefreshZoom: function() {
    if (0 == roar.touch && ("zoom" == window.main_image_display || "both" == window.main_image_display) && $(".elevatezoom").length) {
      $(".elevatezoom .img-zoom").elevateZoom({
        gallery: "gallery_main",
        galleryActiveClass: "active",
        zoomType: "inner",
        cursor: "pointer",
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: !0,
        easing: !0,
        loadingIcon: window.loader_gif
      }), "both" == window.main_image_display && $(".elevatezoom .img-zoom").bind("click", function(a) {
        var b = $(".elevatezoom .img-zoom").data("elevateZoom");
        return $.fancybox(b.getGalleryList(), {
          closeBtn: !1,
          helpers: {
            buttons: {}
          }
        }), !1
      })
    }
  },
  handleImageThumbs: function() {
    $("#gallery_main").length && (roar.touch ? $("#product-image .main-image").on("click", function() {
      var a = [],
          b = 0;
      return $("#product-image .image-thumb").each(function(c, d) {
        a.push({
          href: d.href,
          title: d.title
        }), $(this).hasClass("active") && (b = c)
      }), $.fancybox(a, {
        closeBtn: !1,
        index: b,
        openEffect: "none",
        closeEffect: "none",
        nextEffect: "none",
        prevEffect: "none",
        helpers: {
          buttons: {}
        }
      }), !1
    }) : "lightbox" == window.main_image_display && $("#product-image .fancybox").on(roar.clickEv, function() {
      var a = [],
          b = 0;
      return $("#product-image .image-thumb").each(function(c, d) {
        a.push({
          href: d.href,
          title: d.title
        }), $(this).hasClass("active") && (b = c)
      }), $.fancybox(a, {
        closeBtn: !1,
        index: b,
        helpers: {
          buttons: {}
        }
      }), !1
    }), $("#product-image").on("click", ".image-thumb", function() {
      var a = $(this);
      if (!a.hasClass("active")) {
        var b = $(".product-image .main-image .main-image-bg"),
            c = a.parents(".product-image-wrapper"),
            d = a.attr("data-image-zoom"),
            e = a.attr("data-image");
        b.show(), c.find(".image-thumb").removeClass("active"), a.addClass("active"), c.find(".main-image").find("img").attr("data-zoom-image", d), c.find(".main-image").find("img").attr("src", e).load(function() {
          b.hide()
        })
      }
      return !1
    }))
  },
  alwaysRefreshZoomQS: function() {
    if (0 == roar.touch && ("zoom" == window.main_image_display || "both" == window.main_image_display) && $(".elevatezoom_qs").length) {
      $(".elevatezoom_qs .img-zoom").elevateZoom({
        gallery: "gallery_main_qs",
        galleryActiveClass: "active",
        zoomType: "window",
        cursor: "pointer",
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: !0,
        easing: !0,
        loadingIcon: window.loader_gif
      }), "both" == window.main_image_display && $(".elevatezoom_qs .img-zoom").bind("click", function(a) {
        var b = $(".elevatezoom_qs .img-zoom").data("elevateZoom");
        return $.fancybox(b.getGalleryList(), {
          closeBtn: !1,
          helpers: {
            buttons: {}
          }
        }), !1
      })
    }
  },
  alwaysScrollThumbsQS: function() {
    $("#gallery_main_qs").length && $("#quick-shop-image").on(roar.clickEv, ".image-thumb", function() {
      var a = $(this),
          b = $(".product-image .main-image .main-image-bg"),
          c = a.parents(".product-image-wrapper"),
          d = a.attr("data-image-zoom"),
          e = a.attr("data-image");
      return b.show(), c.find(".image-thumb").removeClass("active"), a.addClass("active"), c.find(".main-image").find("img").attr("data-zoom-image", d), c.find(".main-image").find("img").attr("src", e).load(function() {
        b.hide()
      }), !1
    })
  },
  goToPage: function() {
    $(".action_page").click(function(a) {
      var b = $(this).parent(),
          c = $(".go_page", b).val();
      Shopify.queryParams.page = c, location.search = $.param(Shopify.queryParams)
    }), $(".go_page").on("keypress", function(a) {
      if ("13" == a.which) {
        var b = $(this).val();
        Shopify.queryParams.page = b, location.search = $.param(Shopify.queryParams)
      }
    })
  },
  handleTooltip: function() {
    $(".btooltip").length && $(".btooltip").tooltip()
  },
  handleTabs: function() {
    $("body").on("click", ".nav-tabs a", function(a) {
      a.preventDefault(), $(this).tab("show")
    })
  },
  handleSortby: function() {
    "undefined" != typeof val_default && (jQuery(".sortBy li.sort-by").removeClass("active"), jQuery(".sortBy li." + val_default).addClass("active"), jQuery(".sortBy li.sort-by").click(function() {
      if (!$(this).hasClass("active")) {
        var a = jQuery(this).attr("data-sort");
        Shopify.queryParams.sort_by = a, location.search = jQuery.param(Shopify.queryParams)
      }
    }))
  },
  sortSandBox: function(){
    var listSB = $('#sandBox .product');
    listSB.removeClass('first');
    $("#sandBox .product:nth-child(4n)").addClass('first');
  },

  handleProducts: function(){
    var firstrun = true,
        liveEffects = ['fade','scale'],
        liveEasing = 'smooth',
        liveSpeed = 500,
        touch = false,
        list = false,
        clickEv = 'click';
    if($('#sandBox').length)
      $('#sandBox').mixitup({
        buttonEvent: clickEv,
        onMixStart: function(config){

          // PAUSE LOGO ON SANDBOX ACTIVITY
          if(typeof timer != 'undefined'){
            clearInterval(timer);
          };
          if(typeof counter != 'undefined'){
            clearInterval(counter);
          };

          // UPDATE EFFECTS LIST
          config.effects = liveEffects;

          // UPDATE EASING
          config.easing = liveEasing;

          // UPDATE SPEED
          config.transitionSpeed = liveSpeed;

          return config;
        },
        onMixEnd: function(config){

          // ADD LIST STYING
          var wait = setTimeout(function(){
            if(config.layoutMode == 'list'){
              list = true;
            };

            roar.sortSandBox();

            // rebind add to cart event
            $('.add-to-cart').bind( 'click', addToCart );

          },100);
        }
      });
  },
  getRandomInt: function(a, b) {
    return Math.floor(Math.random() * (b - a + 1)) + a
  },
  mockupResponsiveSlider: function() {
    var a = new Array;
    a[0] = "slideAppearRightToLeft", a[1] = "slideAppearLeftToRight", a[2] = "slideAppearUpToDown", a[3] = "slideAppearDownToUp", $("#home-slider [data-animate]").each(function() {
      var b = roar.getRandomInt(0, 3),
          c = a[b];
      $(this).attr("data-animate", c)
    })
  },
  mockupCameraSlideshow: function() {
    var a = new Array;
    a[0] = "moveFromLeft", a[1] = "moveFomRight", a[2] = "fadeIn", a[3] = "fadeFromLeft", a[4] = "fadeFromRight", $("#home-slider .camera_caption").each(function() {
      var b = roar.getRandomInt(0, 4),
          c = a[b];
      $(this).removeClass("fadeIn").addClass(c)
    })
  },
  handleSlideshow: function() {
    $("#home-slider").length && ("camera" == window.show_slideshow ? $("#home-camera-slider").camera({
      loader: "none",
      autoAdvance: window.slideshow_auto,
      mobileAutoAdvance: window.slideshow_auto,
      pagination: window.show_slideshow_dots,
      thumbnails: !1,
      playPause: !1
    }) : "responsive" == window.show_slideshow && (roar.mockupResponsiveSlider(), $("#home-slider").responsiveSlider({
      autoplay: window.slideshow_auto,
      interval: window.slideshow_interval,
      transitionTime: 300
    }), imagesLoaded("#home-slider", function() {
      $("#home-slider-overlay").hide()
    })))
  },
  handleMap: function() {
    $("#contact_map").length && jQuery().gMap && $("#contact_map").gMap({
      zoom: window.contact_zoom,
      scrollwheel: window.contact_scroll,
      maptype: window.contact_type,
      markers: [{
        address: window.contact_address,
        html: "_address",
        icon: {
          image: window.contact_icon,
          iconsize: [188, 68],
          iconanchor: [0, 68]
        }
      }]
    })
  },
  handleGridList: function() {
    $(".make-switch").on("switch-change", function(a, b) {
      1 == b.value ? ($("#sandBox").removeClass("full_width"), $("#sandBox").find(".product-images").removeClass("span4"), $("#sandBox").find(".product-contents").removeClass("span8")) : ($("#sandBox").addClass("full_width"), $("#sandBox").find(".product-images").addClass("span4"), $("#sandBox").find(".product-contents").addClass("span8"))
    })
  },
  handleMenuScroll: function(a) {
    var b = $("#header").outerHeight();
    !roar.touch && roar.getWidthBrowser() >= 1024 && (a > b ? $("#header").hasClass("on") || ($("body").hasClass("templateIndex") || $('<div style="min-height:' + b + 'px"></div>').insertBefore("#header"), $("#header").addClass("on").addClass("fadeInDown")) : $("#header").hasClass("on") && ($("body").hasClass("templateIndex") || $("#header").prev().remove(), $("#header").removeClass("on").removeClass("fadeInDown")))
  },
  handleResetMenuScroll: function() {
    if (roar.getWidthBrowser() < 1024) $("#header").hasClass("on") && ($("body").hasClass("templateIndex") || $("#header").prev().remove(), $("#header").removeClass("on").removeClass("fadeInDown"));
    else {
      var a = $(this).scrollTop(),
          b = $("#header").outerHeight();
      a > b && ($("#header").hasClass("on") || ($("body").hasClass("templateIndex") || $('<div style="min-height:' + b + 'px"></div>').insertBefore("#header"), $("#header").addClass("on").addClass("fadeInDown")))
    }
  },
  handleMenuMobile: function() {
    $("#header .navbar .nav li > .dropdown-link").click(function() {
      return !(roar.getWidthBrowser() < 980) && void 0
    }), $("#header .navbar .nav li > .dropdown-link .icon-caret-down").click(function() {
      if (roar.getWidthBrowser() < 980) {
        var a = $(this).parent().parent();
        a.hasClass("open") ? a.removeClass("open") : a.addClass("open")
      }
    }), $("#header .navbar .nav li > .dropdown-link > span").click(function() {
      if (getWidthBrowser() < 980) {
        var a = $(this).parent();
        window.location = a.attr("href")
      }
    })
  },
  resetProductImg: function() {
    $("#product-image #main-image").load(function() {
      $(".main-image-bg").hide(), $("#product-image .main-image div").hide()
    })
  },
  callbackSearchMobile: function() {
    var a = $(".is-mobile .is-mobile-search .icon-search"),
        b = $(".is-mobile .is-mobile-search .icon-remove"),
        c = $(".is-mobile .is-mobile-search .input-search"),
        d = $(".is-mobile .is-mobile-search");
    a.click(function() {
      d.addClass("on")
    }), c.click(function() {
      return !1
    }), b.click(function() {
      d.removeClass("on")
    })
  },
  ajaxAllProducts: function() {
    var a = new Array;
    return $.ajax({
      type: "GET",
      url: "/collections/all?view=ajax",
      beforeSend: function() {},
      success: function(b) {
        $(b).find(".p").each(function() {
          var b = $.trim(this.getAttribute("data-t")),
              c = $.trim(this.getAttribute("data-h")),
              d = new Object;
          d.title = b, d.handle = c, a.push(d)
        })
      },
      dataType: "html"
    }), a
  },
  handleAjaxSearch: function() {
    if (window.header_search_ajax) {
      var a = roar.ajaxAllProducts();
      $("#input-ajax").keyup(function() {
        var b = $(this),
            c = $.trim(b.val().toLowerCase());
        if ($("#result-ajax").hide(), c.length >= 3) {
          for (var d = $("#result-ajax .wrapper-ajax").empty(), e = 0; e < a.length; e++) {
            var f = a[e],
                g = f.title,
                h = f.handle;
            if (g.toLowerCase().indexOf(c) > -1) {
              var i = g.replace(new RegExp("(" + c + ")", "gi"), '<span class="marked">$1</span>'),
                  j = '<li><a href="/products/' + h + '">' + i + "</a></li>";
              d.append(j)
            }
          }
          $("#result-ajax .wrapper-ajax li").length && $("#result-ajax").show()
        } else $("#result-ajax").hide()
          }), $(this).click(function(a) {
        $(a.target).parent("#result-ajax").length > 0 || $("#result-ajax").hide()
      })
    }
  },
  handleCountdown: function() {
    $(".count_holder_big").each(function() {
      var a = $(this).find(".count_holder_small");
      $(this).hover(function() {
        a.addClass("hover").appendTo("body")
      }, function() {
        a.removeClass("hover").appendTo(this)
      }).mousemove(function(b) {
        var c = b.pageX + 60,
            d = b.pageY - 50,
            e = a.width(),
            g = (a.height(), $(window).width() - (c + e));
        $(window).height(), 50 > g && (c = b.pageX - e - 60), a.css({
          left: c,
          top: d
        })
      })
    })
  },
  handleSmoothScroll: function() {
    $("body").on("click", ".smoothscroll", function(a) {
      a.preventDefault();
      var b = $(this).attr("href");
      $("html,body").animate({
        scrollTop: $(b).offset().top - 50
      }, 800, "swing")
    })
  },
  notifyIE7Users: function() {
    if ($("html").hasClass("ie7"))
      if ("" != window.notify_ie7_page) $.ajax({
        type: "GET",
        url: "pages/" + window.notify_ie7_page,
        beforeSend: function() {},
        success: function(a) {
          var b = $(a).find("#col-main > .page");
          $("body").html(b.html()).show()
        },
        dataType: "html"
      });
      else {
        var a = "<h1>Unsupported Browser</h1>";
        $("body").html(a).show()
      }
  },
  callbackLoaded: function() {
    $("#product-related").length && ("scroll" == window.productspg_featured_style ? $("#product-related").mCustomScrollbar({
      horizontalScroll: !0,
      scrollInertia: 100
    }) : "carousel" == window.productspg_featured_style && ("none" == window.sidebar_product_placement ? $("#product-related").owlCarousel({
      navigation: !0,
      pagination: !1,
      mouseDrag: !1,
      items: 4,
      itemsDesktop: [1199, 4],
      itemsDesktopSmall: [979, 3],
      itemsTablet: [768, 2],
      itemsMobile: [479, 1],
      scrollPerPage: window.productspg_featured_scroll,
      navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
    }) : $("#product-related").owlCarousel({
      navigation: !0,
      pagination: !1,
      mouseDrag: !1,
      items: 3,
      itemsDesktop: [1199, 3],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsMobile: [479, 1],
      scrollPerPage: window.productspg_featured_scroll,
      navigationText: ['<span class="btn btn-1 mini"><i class="icon-angle-left"></i></span>', '<span class="btn btn-1 mini"><i class="icon-angle-right"></i></span>']
    }))), imagesLoaded("#col-main", function() {
      var a = "";
      a = setInterval(function() {
        $("#loading-loader").hide(), clearInterval(a)
      }, 500)
    })
  },
  detectPlatform: function() {
    roar.isMobile() ? (roar.touch = !0, $("body").addClass("touch"), roar.clickEv = "touchstart") : ($("body").addClass("notouch"), -1 != navigator.appVersion.indexOf("Mac") && navigator.userAgent.indexOf("Safari") > -1 && $("body").addClass("macos"))
  },
  calHeaderHeight: function() {
    var a = $("#header").height();
    $("body").css("padding-top", a + "px")
  },
  addToWishlist: function() {
    $(document).on("click", ".add_to_wishlist:not(.added)", function(a) {
      if (!$(this).hasClass("need-login")) {
        a.preventDefault();
        var b = $(this),
            c = b.closest("form"),
            d = {
              action: "add_wishlist"
            };
        return d = c.serialize() + "&" + $.param(d), $.ajax({
          type: "POST",
          url: "/a/wishlist",
          async: !0,
          cache: !1,
          data: d,
          dataType: "json",
          beforeSend: function() {
            b.hasClass("tooltip") ? b.addClass("loading") : b.attr("title", b.attr("data-loading-text")).find("span").text(b.attr("data-loading-text"))
          },
          error: function(a) {
            console.log(a)
          },
          success: function(a) {
            b.hasClass("tooltip") && b.removeClass("loading");
            var c = $(".wishlist" + b.prev().val());
            1 == a.code ? (c.attr("title", b.attr("data-added")).addClass("added").find("span").text(b.attr("data-added")), $(".wishlist_items_number").text(a.json)) : (c.attr("title", b.attr("data-title")).find("span").text(b.attr("data-title")), alert(a.json), console.log(a.json))
          }
        }), !1
      }
    })
  },
  removeFromWishlist: function() {
    $(document).on("click", ".remove_from_wishlist", function(a) {
      a.preventDefault();
      var b = $(this),
          c = b.closest("form"),
          d = {
            action: "remove_wishlist"
          };
      return d = c.serialize() + "&" + $.param(d), $.ajax({
        type: "POST",
        url: "/a/wishlist",
        async: !0,
        cache: !1,
        data: d,
        dataType: "json",
        beforeSend: function() {
          $(".page-wishlist").addClass("loading")
        },
        error: function(a) {
          console.log(a), $(".page-wishlist").removeClass("loading")
        },
        success: function(a) {
          1 == a.code ? b.closest("tr").slideUp("fast", function() {
            b.closest("tr").remove(), $(".page-wishlist .infos").removeClass("hide"), $(".wishlist_items_number").text(a.json), 0 == a.json && $(".wishlist-empty").removeClass("hide")
          }) : (alert(a.json), console.log(a.json)), $(".page-wishlist").removeClass("loading")
        }
      }), !1
    })
  }
};
$(window).resize(function() {
  window.header_sticky && roar.handleResetMenuScroll()
}), $(window).scroll(function() {
  if (window.header_sticky) {
    var a = $(this).scrollTop();
    roar.handleMenuScroll(a)
  }
}), jQuery(document).ready(function(a) {
  initMegaMenu(), roar.init(), NProgress.done(), $(".is-mobile-menu .btn-navbar").click(function(a) {
    var b = $(this).attr("data-target");
    $(b).toggleClass("in")
  })
});